import { WerbeZustimmungModel } from '../../../../../shared/models/view/WerbeZustimmung';
import { PartnerViewModel } from '../../../../../shared/models/view/Partner';
import { ChildModel } from '../../../../../shared/models/view/Child';
import { MembershipBonusModel } from '../../../../../shared/models/view/MembershipBonus';
import { AppUtils } from '../../../../../shared/utils/index';

export class AppFormModel {

	constructor() {
		this.Bonus = new MembershipBonusModel();
	}

	private partner: PartnerViewModel;
	public get Partner(): PartnerViewModel {
		return this.partner;
	}
	public set Partner(v: PartnerViewModel) {
		this.partner = v;
	}

	private kinder: Array<ChildModel> = new Array<ChildModel>();
	public get Kinder(): Array<ChildModel> {
		return this.kinder;
	}
	public set Kinder(v: Array<ChildModel>) {
		this.kinder = v;
	}

	private werbeZustimmungModel: WerbeZustimmungModel;
	public get WerbeZustimmungModel(): WerbeZustimmungModel {
		return this.werbeZustimmungModel;
	}
	public set WerbeZustimmungModel(v: WerbeZustimmungModel) {
		this.werbeZustimmungModel = v;
	}

	private bestimmungenAkzeptiert: boolean;
	public get BestimmungenAkzeptiert(): boolean {
		return this.bestimmungenAkzeptiert;
	}
	public set BestimmungenAkzeptiert(v: boolean) {
		this.bestimmungenAkzeptiert = v;
	}

	private wiederrufAkzeptiert: boolean;
	public get WiederrufAkzeptiert(): boolean {
		return this.wiederrufAkzeptiert;
	}
	public set WiederrufAkzeptiert(v: boolean) {
		this.wiederrufAkzeptiert = v;
	}

	private bonus: MembershipBonusModel;
	public get Bonus(): MembershipBonusModel {
		return this.bonus;
	}
	public set Bonus(value: MembershipBonusModel) {
		this.bonus = value;
	}

	private profiwerbernummer: string;
	public get Profiwerbernummer(): string {
		return this.profiwerbernummer;
	}
	public set Profiwerbernummer(value: string) {
		this.profiwerbernummer = value;
	}

	private pruefziffer: number;
	public get Pruefziffer(): number {
		return this.pruefziffer;
	}
	public set Pruefziffer(value: number) {
		this.pruefziffer = value;
	}

	private werbeschluessel: number;
	get Werbeschluessel(): number {
		return this.werbeschluessel;
	}
	set Werbeschluessel(value: number) {
		this.werbeschluessel = value;
	}

	private officeWerbeschluessel: number;
	get OfficeWerbeschluessel(): number {
		return this.officeWerbeschluessel;
	}
	set OfficeWerbeschluessel(value: number) {
		this.officeWerbeschluessel = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): AppFormModel {
		return AppUtils.Helper.createFromMap(dataObject, AppFormModel, (key: string, value: any) => {
			switch (key) {
				case 'partner':
					return PartnerViewModel.createFromObject(value);
				case 'kinder':
					return value.map((child: { [key: string]: any }) => ChildModel.createFromObject(child));
				case 'werbeZustimmungModel':
					return WerbeZustimmungModel.createFromObject(value);
				case 'bonus':
					return MembershipBonusModel.createFromObject(value);
				default:
					return value;
			}
		});
	}
}